// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "" + chunkId + "-" + {"88":"5520c4c56caf10a6ec68","105":"3da9412e8c965f656f82","108":"f03079819f8757c97349","243":"b9e49f0c4364bb5ead67","682":"010d3484390bfdcb1778","688":"106a82ccdf926e59d00d","852":"499bd492081ec008dd5f"}[chunkId] + ".bundle.js";
};